<app-label
  class="text-navy-90"
  [icon]="'linked'"
  [type]="'transparent'"
  [name]="numberOfControls | i18nPlural: controlLabelMapping | translate: { numberOfControls }"
  [isHoverable]="false"
  [ngbTooltip]="numberOfControls ? linkedControlsTemplate : null"
  [tooltipClass]="'default-tooltip max-w-10/12'"
  [placement]="tooltipPlacement"
  [keepOnHover]="true"
  (click)="isMobile && $event.stopPropagation()"
></app-label>

<ng-template #linkedControlsTemplate>
  <div class="flex flex-col max-h-2/5-dvh overflow-y-auto pr-2">
    <span class="font-bold">
      {{ buildTranslationKey('linkedTo') | translate }}
      {{ numberOfControls | i18nPlural: controlLabelMapping | translate: { numberOfControls } }}:
    </span>

    @for (framework of linkedFrameworks; track $index) {
      <div>
        <ng-container *ngVar="requirement?.linked_frameworks[framework] as controls">
          @if (controls?.length) {
            <div class="font-bold mt-3 mb-2">{{ framework }}:</div>

            @for (control of controls; track $index) {
              <div class="pl-2.5">{{ control }}</div>
            }
          }
        </ng-container>
      </div>
    }
  </div>
</ng-template>
